import { GetRoomData, Teleportsucces } from "@shared/types";
import { PlayerService } from "./PlayerService";

export class MapService {
    public async teleportToRoom(alias: string): Promise<Teleportsucces > {
        console.log(`${VITE_API_URL}game/teleport`);
        const response: Response = await fetch(`${VITE_API_URL}game/teleport`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
            },
            body: JSON.stringify({ newRoom: alias }),
        });
        console.log("Teleporting to room:", alias);
        if (!response.ok) {
            console.error("Failed to teleport:", response.statusText);
            throw new Error("Failed to teleport");
        }
        return await response.json() as Teleportsucces;
    }

    private _playerService: PlayerService = new PlayerService();
    public async fetchRooms(): Promise<GetRoomData[] | undefined> {
        const response: Response = await fetch(`${VITE_API_URL}game/rooms`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
            },
        });
        console.log(response);
        if (parseInt(response.headers.get("content-length")!) > 0) {
            return response.json() as Promise<GetRoomData[]>;
        }
        return undefined;
    }
}
